import { useCallback, useMemo } from 'react';
import { useQuery, useMutation } from '@ts-core/lib/apollo';

import { useMutationCompletionHandler, getErrorMessage } from '@ts-core/lib/apollo';

import { getLessonsQuery } from '../graphql/queries';
import { deleteLessonMutation } from '../graphql/mutations';

export default function useLessons({ courseId, groupId }) {
  const { onError, removeItemFromCache } = useMutationCompletionHandler();

  /**
   * Get Lessons
   */
  const { data, loading, error } = useQuery(getLessonsQuery, {
    variables: { courseId, groupId },
    skip: !courseId || !groupId,
  });
  const lessons = useMemo(() => data?.lessons || [], [data]);

  /**
   * Delete Lesson
   */
  const [deleteLesson] = useMutation(deleteLessonMutation, {
    onError,
    update: removeItemFromCache({
      query: getLessonsQuery,
      variables: { courseId, groupId },
      queryField: 'lessons',
      mutationField: 'lesson',
    }),
  });
  const onDeleteLesson = useCallback(
    (lesson) => {
      deleteLesson({ variables: { courseId, groupId, lessonId: lesson._id } });
    },
    [deleteLesson, courseId, groupId]
  );

  return {
    lessons,
    loading,
    error: getErrorMessage({ error }),

    onDeleteLesson,
  };
}
